export default __webpack_public_path__ + "static/media/spotify.50ef2792.svg";